import React from "react";
import { CustomComponentCustomFormField, CustomFormSelection, basicValidation } from "../../../../../amorg-common";
import { AnswerFieldContext } from "../../customFormFieldFactory";
import { RiskAssessmentHelper } from "./_components/RiskAssessmentHelper";

type Kim1RiskAssessmentCustomFormFieldComponentProps = AnswerFieldContext & {
    field:CustomComponentCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Kim1RiskAssessmentCustomFormFieldComponent(props:Kim1RiskAssessmentCustomFormFieldComponentProps):JSX.Element
{
    const timePointsField = props.answer.selections.find(s => s.fieldId === 'timePoints');
    const timePoints = parseNumberValue(timePointsField);

    const weightField = props.answer.selections.find(s => s.fieldId === 'weight');
    const weight = parseNumberValue(weightField);

    const positionField = props.answer.selections.find(s => s.fieldId === 'position');
    const position = parseNumberValue(positionField);
    
    const workAreaField = props.answer.selections.find(s => s.fieldId === 'workArea');
    const workArea = parseNumberValue(workAreaField);

    const riskField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const risk = parseNumberValue(riskField);

    const newRiskAssessmentValue = (weight+position+workArea) * timePoints;
    const oldRiskAssessmentValue = risk || 0;

    React.useEffect(() => {
        const updateRiskAssessment = async (value:number) => {
            await props.onSubmit([{ fieldId:props.field.fieldId, value:value.toString()}]);
            props.doUpdate();
        };

        if(newRiskAssessmentValue !== oldRiskAssessmentValue)
        {
            updateRiskAssessment(newRiskAssessmentValue);
        }

    }, [timePoints, weight, position, workArea]);
    
    return (
        <RiskAssessmentHelper
            {...props}
            riskAssessmentField={props.field}
            sumElements={[
                { text:'Belastning', value:weight },
                { text:'Arbejdsstilling', value:position },
                { text:'Arbejdsforhold', value:workArea }
                
            ]}
            factorElements={[
                { text:'Tidspoint', value:timePoints }
            ]}
            document="kim1"
        />
    );
}

function parseNumberValue(field:CustomFormSelection):number | null
{
    if(field === null)
        return null;

    if(!basicValidation.validateIntegerString(field.value))
        return null;

    return parseInt(field.value);
}